import cloneIcon from "../../images/Clone.svg";
import {
  cloneSlide,
  AddMasterSlideToDeck,
  geteDetailByID,
} from "../../services/apis";
import { useNavigate } from "react-router-dom";
import { showSuccessToast } from "../toastComponent/ToastComponent";
const CloneSlideTemplate = ({
  currentSlide,
  setCurrentSlide,
  setSlideCountDisplay,
  setSlideID,
  setSlideCount,
  slideNameCount,
  setSlideNameCount,
  appData,
  setCloneLoading,
}) => {
  const navigate = useNavigate();
  const cloneMaster = () => {
    setCloneLoading(true);
    cloneSlide(
      currentSlide.master?.slideid?._id,
      (response, err, errorCode) => {
        if (err) {
        } else {
          // console.log(response, "responsePatch"); // here we get slides

          setCurrentSlide({
            master: {
              //index: index,
              index: currentSlide?.master?.index + 1,
              slideid: {
                name: response.data.name,
                key_message: response.data.key_message,
                _id: response.data._id,
                thumbnail: response.data.thumbnail,
              },
              children: [],
            },
            child: {},
          });
          showSuccessToast('Successfully cloned the slide.');
          setSlideCount(currentSlide?.master?.index + 1);
          //setSlideNameCount(slideNameCount + 1);
          //  setSlideCountDisplay(currentSlide?.master?.index + 1);
          //setSlideID(data.slides);
          // setEnableAdd(true);
          // saveContentWhencrated(data._id);
          navigate(`/editor/${response.data._id}`, { replace: true });

          const payload = {
            slides: [
              {
                index: currentSlide?.master?.index + 1,
                slideid: response.data._id,
                children: [],
              },
            ],
          };
          AddMasterSlideToDeck(
            response.data.member_of[0],
            payload,
            (response, err, errorCode) => {
              if (err) {
              } else {
                // console.log(response, "responsePatch"); // here we get slides
                // setSlideID(response.data.slides);

                geteDetailByID(
                  appData?.deckId?._id,
                  async (response, err, errorCode) => {
                    if (err) {
                    } else {
                      let data = await response.data;

                      setSlideID(data.slides);
                    }
                  }
                );
                //setSlideNameCount(slideNameCount + 1);
              }
            }
          );
        }
        setCloneLoading(false);
      }
    );
  };

  return (
    <>
      <div
        onClick={() => cloneMaster()}
        // onClick={validateDelete}
        // className={getClassName() + "ignoreClick"}
        className="d-flex align-items-center"
      // style={{ display: "flex" }}
      >
        <img src={cloneIcon} alt="clone Slide" className="ignoreClick" />
        <h2>Clone Slide</h2>
      </div>
    </>
  );
};

export default CloneSlideTemplate;
